import { useContext } from 'react'
import { DocumentPreviewContext } from './documentPreviewContextValue.js'

export function useDocumentPreviewOptional() {
  return useContext(DocumentPreviewContext)
}

export function useDocumentPreview() {
  const ctx = useDocumentPreviewOptional()
  if (!ctx) throw new Error('useDocumentPreview must be used inside DocumentPreviewProvider')
  return ctx
}
